"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createText = createText;
exports.createNumber = createNumber;
exports.createAmount = createAmount;
exports.getHeaderName = getHeaderName;
exports.getHeaderUnit = getHeaderUnit;
exports.getValue = getValue;
const uom_1 = require("uom");
const uom_2 = require("@genesys/uom");
function createText(name, value, values) {
    return {
        type: "text",
        name: name,
        value: value,
        values: values
    };
}
function createNumber(name, value) {
    return {
        type: "number",
        name: name,
        number: value
    };
}
function createAmount(name, value, unitSi, unitIp) {
    return {
        type: "amount",
        name: name,
        value: value,
        unitSi: unitSi,
        unitIp: unitIp
    };
}
function getHeaderName(value) {
    return value.name;
}
function getHeaderUnit(value, si) {
    switch (value.type) {
        case "text":
            return `[${value.values.reduce((a, b) => a + ", " + b)}]`;
        case "number":
            return "[Number]";
        case "amount":
            return `[${uom_1.Serialize.unitToString(si ? value.unitSi : value.unitIp)}]`;
        default:
            throw new Error("Unknown value type");
    }
}
function getValue(value, si) {
    switch (value.type) {
        case "text":
            return value.value;
        case "number":
            return value.number.toString();
        case "amount": {
            const unit = si ? value.unitSi : value.unitIp;
            const format = uom_2.Format.getUnitFormat(unit, uom_2.UnitsFormat);
            return uom_1.Amount.valueAs(unit, value.value).toFixed(format.decimalCount);
        }
        default:
            throw new Error("Unknown value type");
    }
}
//# sourceMappingURL=value.js.map